import { StatusKey } from '@/Enums/Agencies/StatusKey.enum';
import { IAgencyGridRow, IAgencyResponseItem } from '@/Interfaces/Agency.interface';
import { IPaginatedApiResponse } from '@/Interfaces/ApiResponse/PaginatedApiResponse.interface';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import { getControlOptionsValues } from '@/helpers/filters/filterMapping';
import { getSortFilter } from '@/helpers/grid/getSortFilter';
import { SearchAgenciesFilters } from '@/types/agencies.types';

export const transformAgenciesFilters = (filters: SearchAgenciesFilters) => {
  const { status, whitelabels, clients, sort, ...payload } = filters;

  return {
    ...payload,
    ...(status !== StatusKey.ALL ? { status } : {}),
    sort: getSortFilter(sort),
    whitelabelIds: getControlOptionsValues(whitelabels),
    clientIds: getControlOptionsValues(clients),
  };
};

export const formatAgenciesResponseData = ({
  data,
  meta,
}: IPaginatedApiResponse<IAgencyResponseItem[]>): { data: IAgencyGridRow[]; total: number } => {
  return {
    data: data.map(agency => ({
      id: agency.id,
      name: agency.name,
      status: agency.status,
      createdAt: agency.created_at,
      client: agency.client
        ? {
            value: agency.client.id,
            label: agency.client.name,
          }
        : null,
      advertisers: agency.advertisers?.length
        ? agency.advertisers.map(
            advertiser =>
              ({
                value: advertiser.id,
                label: advertiser.name,
              }) as IControlOption,
          )
        : [],
    })),
    total: meta.total,
  };
};
